import { H1 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const DealerH1 = styled(H1)`
  padding-bottom: ${theme.spacing.md};
`
